// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import regComponents from '@common/reg-components'
import filter from '@common/filter/index.js'
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/index.scss'
import '@/assets/iconfont/iconfont.css'
import RouterHookLogic from "@common/routerHookLogic";
require('@common/permission')
require('@common/validator-rule') //todo按需
require('@common/directive')
Vue.use(ElementUI, { size: 'mini' })
Vue.use(regComponents)
Vue.prototype.$echarts = echarts
// 过滤器
for (let key in filter) {
  Vue.filter(key, filter[key]);
}


import websocket from '@/common/websocket'

Vue.prototype.$websocket = websocket;

require('@common/data-access')
Vue.use(RouterHookLogic, { router, store });

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  data: {
    eventHub: new Vue()
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js